import { render, staticRenderFns } from "./AddressField.vue?vue&type=template&id=4dbece28&scoped=true"
import script from "./AddressField.vue?vue&type=script&lang=ts"
export * from "./AddressField.vue?vue&type=script&lang=ts"
import style0 from "./AddressField.vue?vue&type=style&index=0&id=4dbece28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbece28",
  null
  
)

export default component.exports